// extracted by mini-css-extract-plugin
export default {"crossIcon":"style_crossIcon__c7pGQ","card":"style_card__vmSiN","title":"style_title__948IB","subTitle":"style_subTitle__SNK3h","grid":"style_grid__fkX6e"};